import styles from "./topAccounts.module.scss";
import { Avatar } from "@mui/material";
import AdminSwitchOrg from "../adminSwitchOrg/AdminSwitchOrg";
import { Link } from "react-router-dom";
import { EMPTY_STRING } from "../constant/constant";

interface WalletCardProps {
  id: string;
  avatar: string;
  name: string;
  type: string;
  bg?: string;
  currentId: string;
}

export default function TopAccounts({ id, avatar, name, type, bg, currentId }: WalletCardProps) {
  return (
    <div className={styles.WalletCard}>
      <div className={styles.card}>
        <Link to={`/organisation/${id}`} aria-label={`View  ${name}`}>
          <div className={styles.cardHolder}>
            <div className={styles.cardHolderImg}>
              {/* <img src={avatar} alt="Avatar" /> */}
              <Avatar id="av" className={styles.av} aria-label="Recipe" style={{ backgroundColor: bg }}>
                {avatar}
              </Avatar>
            </div>
            <div className={styles.cardHolderName}>
              <h2>{name}</h2>
              <p>{type}</p>
            </div>
          </div>
        </Link>
        <AdminSwitchOrg orgId={id} buttonStyle={{ width: "-webkit-fill-available" }} />
      </div>
      <div className={styles.currentOrgLabel} style={{ display: id === currentId ? EMPTY_STRING : "none" }}>
        Current
      </div>
    </div>
  );
}
